import { TopSalesPage } from "@/components/analyze-topSales/topSales-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/topseller/$kundennummer")({
  component: TopSalesPage,
});
